import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider } from '@contexts/AppContext';
import useEventTracking from '@hooks/useEventTracking';
import { Page } from '@tracking';

import ForYouContent from './Content';
import type { ForYouProps } from './interfaces';

const queryClient = new QueryClient();

const ForYou = ({
  env,
  forumPosts,
  headlineVariant,
  initialCurrentUser,
  isGdprRequired,
  isWebview,
  newsletterNames,
}: ForYouProps) => {
  const { Track } = useEventTracking({
    page: Page.ForYou,
  });

  return (
    <AppContextProvider
      env={env}
      initialCurrentUser={initialCurrentUser}
      isGdprRequired={isGdprRequired}
      isWebview={isWebview}
    >
      <QueryClientProvider client={queryClient}>
        <Track>
          <ForYouContent
            forumPosts={forumPosts}
            headlineVariant={headlineVariant}
            initialCurrentUser={initialCurrentUser}
            newsletterNames={newsletterNames}
          />
        </Track>
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default ForYou;
